import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const SiteSubjectQueryBarGraph = ({ subjectQuery }) => {
  const [studyOverViewDounuytChart, setStudyOverViewDounuytChart] = useState({
    series: [{ name: "No. of Query", data: subjectQuery || [] }],
    options: {
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
      },
      stroke: { width: 1, colors: ["#fff"] },
      plotOptions: {
        bar: { horizontal: true },
      },
      xaxis: {
        categories: ["Open", "Closed", "Cancelled", "Answered"],
        labels: {
          style: {
            colors: ["#103C5E8C", "#103C5E99", "#103C5E", "#103C5E"],
            fontSize: "12px",
          },
        },
      },
      fill: { opacity: 1 },
      colors: ["#103C5E8C", "#103C5E99", "#103C5E", "#103C5E"],
      legend: {
        position: "bottom",
        showForSingleSeries: true,
      },
    },
  });

  useEffect(() => {
    setStudyOverViewDounuytChart((prevChartData) => ({
      ...prevChartData,
      series: [{ data: subjectQuery || [] }],
    }));
  }, [subjectQuery]);

  return (
    <div className="p-2">
      <ReactApexChart
        options={studyOverViewDounuytChart.options}
        series={studyOverViewDounuytChart.series}
        type="bar"
        height={200}
      />
    </div>
  );
};

export default SiteSubjectQueryBarGraph;
